import React, { FC, ReactNode } from 'react';
import StepModal from '@components/stepModal';

import classnames from 'classnames/bind';
import styles from './tutorialGuide.module.scss';
const cx = classnames.bind(styles);

interface IStepSlide {
  leftContent: ReactNode;
  rightContent: ReactNode;
}

const stepSlideList: IStepSlide[] = [
  {
    leftContent: (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          튜토리얼에서는
          <br />
          역량검사의 응시를 위한
          <br />
          모든 과정을 체험해 볼 수 있어요.
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step2', 'pacc')} />,
  },
  {
    leftContent: (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          중간 중간
          <br />
          쉬어갈 수도 있답니다.
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step3', 'pacc')} />,
  },
  {
    leftContent: (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          튜토리얼을 통해
          <br />
          역량검사를 충분히 연습해 보세요.
          <br />
          지금부터 출발~!
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step4', 'pacc')} />,
  },
];

interface ITutorialGuideModalProps {
  visible: boolean;
  onClose: () => void;
  onApply: () => void;
}
const TutorialGuideModal: FC<ITutorialGuideModalProps> = ({ visible, onClose, onApply }) => {
  return <StepModal visible={visible} onClose={onClose} onApply={onApply} stepSlideList={stepSlideList} />;
};

export default TutorialGuideModal;
